import React from "react";
import styles from "./GenericExpandablePanel.module.css";

export enum Position {
  Left,
  Right,
}
interface GenericExpandablePanelProps {
  children: any;
  position?: Position;
}

const GenericExpandablePanel: React.FunctionComponent<GenericExpandablePanelProps> = ({
  children,
  position = Position.Right,
}) => {
  const positionStyle = position === Position.Left ? { left: "0px" } : { right: "0px" };

  return (
    <div className={styles.panelContainer} style={positionStyle}>
      {children}
    </div>
  );
};

export default GenericExpandablePanel;
